import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { ContactSecondHeadlineModel } from 'src/app/shared/models/abre-cuentas.model';
import { FormatNumberService } from 'src/app/shared/utils/format-number.service';

import { ContactModel } from '../../../shared/models/contact.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { RescueDataModel } from 'src/app/shared/models/rescue-data.model';
import { IRescueData } from 'src/app/shared/interfaces/rescue-data.interface';

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-form-contact-info',
  templateUrl: './form-contact-info.component.html',
  styleUrls: ['./form-contact-info.component.scss'],
})

/**
 * Clase de componente FormContactInfoComponent
 *
 * *FormContactInfoComponent class component*
 *
 * @implements {OnInit}
 */
export class FormContactInfoComponent implements OnInit {

  /**
   * Definición de formulario de contacto
   *
   * *Contact form definition*
   *
   * @access public
   * @type {FormGroup}
   */
  formGroup: FormGroup;

  /**
   * Texto de error para campo de telefono
   *
   * *Error text for phone field*
   *
   * @access public
   * @type {string}
   */
  reactiveErrorPhone = '';

  /**
   * Texto de error para campo de email
   *
   * *Error text for email field*
   *
   * @access public
   * @type {string}
   */
  reactiveErrorEmail = '';

  /**
   * Objeto de información de contacto
   *
   * *Information contact object*
   *
   * @access public
   * @type {ContactModel}
   */
  contactInfo: ContactModel;

  /**
   * Objeto de información de contacto segundo titular
   *
   * *Information contact object*
   *
   * @access public
   * @type {ContactSecondHeadlineModel}
   */
  contactSecondHeadline: ContactSecondHeadlineModel;

  product_select: any;
  has_second_headline: any;
  private rescueData: IRescueData;

  /**
   * Constructor de componente
   *
   * *Component constructor*
   * @param formBuilder
   * @param navigationService
   * @param abreCuentasService
   * @param headerService
   * @param copyService
   */
  constructor(
    private formBuilder: FormBuilder,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private headerService: HeaderService,
    public copyService: CopyService,
    private formatNumber: FormatNumberService,

  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({});
    this.has_second_headline = this.abreCuentasService.getSecondHeadline() ?
      this.abreCuentasService.getSecondHeadline().has_second_headline : false;
    this.setContactInfo();
    this.rescueData = new RescueDataModel();
  }

  /**
   * Función de Angular ejecutada una vez el componente sea cargado, carga los productos a mostrar
   *
   * *Angular function that is run when the component is loaded, charges products to be displayed*
   */
  ngOnInit() {
    this.product_select = this.abreCuentasService.getproductSelected();
    if (this.product_select.product_type != BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      this.getRescueData();
    }
    const email = this.has_second_headline ? this.contactSecondHeadline.email : this.contactInfo.email;
    const phone = this.has_second_headline ? this.contactSecondHeadline.mobile_number : this.contactInfo.mobile_number;
    // const formatNumber = new FormatNumberService();
    this.formGroup = new FormGroup({
      email: new FormControl(email, [
        Validators.required,
        Validators.pattern(
          // tslint:disable-next-line
          /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/),
      ]),
      phone: new FormControl(phone, [Validators.required, Validators.pattern(/^3\d{9}$/), this.formatNumber.numberPhoneValidator()]),
    });
  }

  getRescueData() {
    if (!this.abreCuentasService.rescueDataIsEmpty()) {
      this.rescueData = this.abreCuentasService.getRescueData();
      this.contactInfo.email = this.rescueData.email;
      this.contactInfo.mobile_number = this.rescueData.mobile_number;
    }
  }

  getNumberFormat(value: string) {
    // const formatNumber = new FormatNumberService();
    return this.formatNumber.formatNumberPhone(value);
  }

  /**
   * Se ejecuta cada vez que se inicia la edición de número de teléfono
   *
   * *It executes each time begins the phone editing*
   */
  inputPhone($event: any) {
    const value = $event.target.value;
    const phone = this.getNumberFormat(value);
    $event.target.value = phone.clearValue;
  }

  /**
   * Se ejecuta cada vez que termina la edición de número de teléfono
   *
   * *It executes each time finish the phone editing*
   */
  outPhone($event: any) {
    const value = $event.target.value;
    const phone = this.getNumberFormat(value);
    $event.target.value = phone.format;
  }

  /**
   * Se ejecuta cada vez que hay un cambio sobre el campo de telefono
   *
   * *It executes each time there is a change on phone field*
   */
  reactiveInputChangePhone() {
    if (this.has_second_headline) {
      this.contactSecondHeadline = this.abreCuentasService.getContactInfoSecondHeadline();
      this.contactSecondHeadline.mobile_number = this.formGroup.controls.phone.value;
      this.abreCuentasService.setContactInfoSecondHeadline(this.contactSecondHeadline);
    } else {
      this.contactInfo = this.abreCuentasService.getContactInfo();
      this.contactInfo.mobile_number = this.formGroup.controls.phone.value;
      this.abreCuentasService.setContactInfo(this.contactInfo);
    }
    const controlPhone = this.formGroup.controls.phone as FormControl;
    controlPhone.setValue(controlPhone.value.slice(0, 10));
    controlPhone.setValue(controlPhone.value.replace(new RegExp(/[^\d]/), ''));
  }

  /**
   * Se ejecuta cada vez que hay un cambio sobre el campo de email
   *
   * *It executes each time there is a change on email field*
   */
  reactiveInputChangeEmail() {
    if (this.has_second_headline) {
      this.contactSecondHeadline = this.abreCuentasService.getContactInfoSecondHeadline();
      this.contactSecondHeadline.email = this.formGroup.controls.email.value;
      this.abreCuentasService.setContactInfoSecondHeadline(this.contactSecondHeadline);
    } else {
      this.contactInfo = this.abreCuentasService.getContactInfo();
      this.contactInfo.email = this.formGroup.controls.email.value;
      this.abreCuentasService.setContactInfo(this.contactInfo);
    }
    const controlEmail = this.formGroup.controls.email as FormControl;
    this.reactiveErrorEmail = controlEmail.valid ? '' : this.copyService.copies.form_contact_email_error;
  }

  /**
   * Se ejecuta cada vez que de se da clic en continuar, debe llenar información de contacto e ir a la siguiente pantalla
   *
   * *It executes each time there is a click on continue, it should fill conctact information and go to the next screen*
   */
  next() {
    if (this.has_second_headline) {
      this.contactSecondHeadline = this.abreCuentasService.getContactInfoSecondHeadline();
      this.contactSecondHeadline.email = this.formGroup.controls.email.value;
      this.contactSecondHeadline.mobile_number = this.formGroup.controls.phone.value;
      this.abreCuentasService.setContactInfoSecondHeadline(this.contactSecondHeadline);
      this.setRescueData(this.contactSecondHeadline);
    } else {
      this.contactInfo.mobile_number = this.formGroup.controls.phone.value;
      this.contactInfo.email = this.formGroup.controls.email.value;
      this.abreCuentasService.setContactInfo(this.contactInfo);
      this.setRescueData(this.contactInfo);
    }
    if (this.product_select.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      this.abreCuentasService.getSecondHeadline().has_incomes_second_headline ?
        this.navigationService.nextStep('200') : this.navigationService.nextStep('201');
      return;
    }
    this.navigationService.nextStep('200');
  }

  setRescueData(data: any) {
    this.rescueData.email = data.email;
    this.rescueData.mobile_number = data.mobile_number;
    this.abreCuentasService.setRescueData(this.rescueData);
  }

  /**
   * Valida la información inicial de contacto y si no existe pone los valores en vacio
   *
   * *Validates initial contact information and it does not exist it puts void values*
   */
  setContactInfo() {
    if (this.has_second_headline) {
      const contactSecondInfo = this.abreCuentasService.getContactInfoSecondHeadline();
      if (!contactSecondInfo) {
        this.contactSecondHeadline = new ContactSecondHeadlineModel();
        this.contactSecondHeadline.email = '';
        this.contactSecondHeadline.mobile_number = '';
        this.abreCuentasService.setContactInfoSecondHeadline(this.contactSecondHeadline);
        return;
      }
      this.contactSecondHeadline = contactSecondInfo;
      return;
    }
    const contactInfo = this.abreCuentasService.getContactInfo();
    if (!contactInfo.email || !contactInfo.mobile_number) {
      this.contactInfo = new ContactModel();
      this.contactInfo.email = '';
      this.contactInfo.mobile_number = '';
      this.abreCuentasService.setContactInfo(this.contactInfo);
      return;
    }
    this.contactInfo = contactInfo;
  }
}
